import script from "./PaymentMethodPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodPage.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodPage.vue?vue&type=style&index=0&id=b797e02c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b797e02c"]])

export default __exports__